export default {
  expert: 'EXPERT',
  saleRep: 'SALES_REP',
  customerSupport: 'CUSTOMER_SUPPORT',
};
